module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dq1Pi"))).then(() => parcelRequire('ljYL6'));